import { createReducer } from "typesafe-actions";

export const REQ_NOTICE_LIST = "notice/REQ_NOTICE_LIST";
export const RES_NOTICE_LIST = "notice/RES_NOTICE_LIST";

export const REQ_NOTICE_DETAIL = "notice/REQ_NOTICE_DETAIL";
export const RES_NOTICE_DETAIL = "notice/RES_NOTICE_DETAIL";

export const REQ_CHANGE_FILTER = "notice/REQ_CHANGE_FILTER";
export const RES_CHANGE_FILTER = "notice/RES_CHANGE_FILTER";

export const SET_CHECK_LIST = "notice/SET_CHECK_LIST";

type NoticeAction =
  | ReturnType<typeof reqNoticeList>
  | ReturnType<typeof reqNoticeDetail>
  | ReturnType<typeof setCheckList>;

export type NoticeState = {
  noticeList?: any;
  noticeCount: any;
  noticeTotal: number;
  noticeDetail?: any;
  paging: any;
  checkList: any;
};

const initialState: NoticeState = {
  noticeList: [],
  noticeCount: 0,
  noticeTotal: 0,
  noticeDetail: null,
  paging: null,
  checkList: {
    notice: true,
    e_notice: true,
    update: true,
    event: true,
    etc: true,
  },
};

const notice = createReducer<NoticeState, NoticeAction>(initialState, {
  [RES_NOTICE_LIST]: (state: NoticeState, action: any) => {
    return {
      ...state,
      noticeList: [...state.noticeList, ...action.payload.list],
      noticeCount: action.payload.countMap.showCnt,
      noticeTotal: action.payload.countMap.totalCnt,
      paging: action.payload.paging,
    };
  },
  [RES_NOTICE_DETAIL]: (state: NoticeState, action: NoticeAction) => {
    return { ...state, noticeDetail: action.payload };
  },
  [RES_CHANGE_FILTER]: (state: NoticeState, action: any) => {
    return {
      ...state,
      noticeList: action.payload.list,
      noticeCount: action.payload.countMap.showCnt,
      noticeTotal: action.payload.countMap.totalCnt,
      paging: action.payload.paging,
    };
  },
  [SET_CHECK_LIST]: (state: NoticeState, action: any) => {
    return {
      ...state,
      checkList: {
        ...state.checkList,
        [action.payload]: !state.checkList[`${action.payload}`],
      },
    };
  },
});

export const reqNoticeList = (payload: {
  page?: any;
  poc?: any;
  type?: any;
}) => ({
  type: REQ_NOTICE_LIST,
  payload,
});

export const reqNoticeDetail = (payload: { n_seq: number }) => ({
  type: REQ_NOTICE_DETAIL,
  payload,
});

export const reqChangeFilter = (payload: {
  page?: any;
  poc?: any;
  type?: any;
}) => {
  return {
    type: REQ_CHANGE_FILTER,
    payload,
  };
};

export const setCheckList = (payload: { name: string }) => ({
  type: SET_CHECK_LIST,
  payload,
});

export default notice;
